import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMaximize } from '@fortawesome/free-solid-svg-icons'
import React, { ChangeEvent, createRef, useCallback, useContext, useEffect, useState } from 'react'
import UserContext, { UserContextType } from './UserContext'
import screenfull from 'screenfull'
import cx from 'classnames'
import { CheckboxWithLabel } from './InputWithLabel'

const Header = () => {
  const {
    userContext: { isReadOnly, isAutoResize, isFullscreen, isShowGallery, isShowControls },
    setIsShowControls,
    setIsShowGallery,
    setIsAutoResize,
  } = useContext(UserContext) as UserContextType
  const [isVisible, setIsVisible] = useState(true)
  const ref = createRef<HTMLDivElement>()
  const onMouseEnter = useCallback(() => {
    if (!isVisible) {
      setIsVisible(true)
    }
  }, [isVisible])
  const onMouseLeave = useCallback(() => {
    if (isFullscreen && isVisible) {
      setTimeout(() => {
        setIsVisible(false)
      }, 5000)
    }
  }, [isVisible, isFullscreen])
  useEffect(() => {
    const searchBarElem = ref.current
    if (searchBarElem) {
      searchBarElem.addEventListener('mouseenter', onMouseEnter)
      searchBarElem.addEventListener('mouseleave', onMouseLeave)

      return () => {
        searchBarElem.removeEventListener('mouseenter', onMouseEnter)
        searchBarElem.removeEventListener('mouseleave', onMouseLeave)
      }
    }
  }, [ref, onMouseLeave, onMouseEnter])

  const onToggleSettings = () => {
    setIsShowControls(!isShowControls)
  }
  const onToggleGallery = () => {
    setIsShowGallery(!isShowGallery)
  }
  const onToggleFullScreen = () => {
    if (screenfull.isEnabled) {
      screenfull.toggle()
    } else {
      console.warn('Fullscreen is not supported.')
    }
  }
  const onAutoResizeToggled = (event: ChangeEvent<HTMLInputElement>) => {
    setIsAutoResize(event.target.checked)
  }
  const className = cx('header', { fullScreen: isFullscreen, hide: !isVisible })
  const buttonsClassName = cx('buttons', { readOnly: isReadOnly })

  return (
    <div className={className} ref={ref}>
      <div className="appTitle">
        <div>Multipolar</div>
        <div className="author">by Kevin Irlen</div>
      </div>
      <div className={buttonsClassName}>
        <button className={isFullscreen ? 'selected' : ''} onClick={onToggleFullScreen}>
          <FontAwesomeIcon icon={faMaximize} title="Full Screen" />
        </button>
        <button onClick={onToggleGallery}>{isShowGallery ? 'hide' : 'show'} gallery</button>
        {!isReadOnly && (
          <button onClick={onToggleSettings}>{isShowControls ? 'hide' : 'show'} controls</button>
        )}
        <CheckboxWithLabel
          label="fit to window"
          value={isAutoResize}
          onChange={onAutoResizeToggled}
        />
      </div>
    </div>
  )
}

export default Header
